import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';

import { ActivatedRoute, Router } from '@angular/router';

// import { NotificationModel } from 'src/app/Models/notification.model';

import { CommonService, SiteService } from 'src/app/services/index';
import {
  AlertService,
  ConfirmationDialog,
  Constants,
  DateService
} from 'src/app/shared/index';
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  displayedColumns = [
    'select',
    'refNo',
    'criticalityLevel',
    'loadName',
    'parameter',
    'ConditionwithValue',
    'firstStartTime',
    'occurrenceCounter',
    'lastStartTime',
    'lastEndTime'
  ];
  faultdisplayedColumns = [
    'slno',
    'faultname',
    'loadname',
    'starttime',
    'endtime',
    'status'
  ];
  faultdata: MatTableDataSource<NotificationModel>;
  dataSource: MatTableDataSource<NotificationModel>;
  public faultarray: any;
  public pageSize = 10;
  public currentPage = 0;
  public totalSize = 0;
  // selection: SelectionModel<NotificationModel> = new SelectionModel<NotificationModel>(true, [ELEMENT_DATA[3]]);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input() siteId: string;

  notificationForm: any = {
    issuedAlertAll: false,
    selectedIssuedAlerts: []
  };

  issuedAlerts: any;
  generatedFaults: any;
  useSlideoverSidebarMode = false;
  selected: any;
  alertType: any;
  notificationDateRange: any;
  notificationDefaultQuery = true;
  alwaysShowCalendars: boolean;
  ranges = {
    Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 days': [moment().subtract(6, 'days'), moment()],
    'Last 30 days': [moment().subtract(29, 'days'), moment()],
    'This month': [moment().startOf('month'), moment().toDate()]
  };
  operators = [
    { value: '=', text: 'Equal to' },
    { value: '!=', text: 'Not Equal to' },
    { value: '>', text: 'Greater Than' },
    { value: '<', text: 'Less Than' },
    { value: '>=', text: 'Greater Than or equal to' },
    { value: '<=', text: 'Less Than or equal to' }
  ];

  constructor(
    private router: Router,
    private dateService: DateService,
    private siteService: SiteService,
    private alertService: AlertService,
    private commonService: CommonService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private activeRoute: ActivatedRoute,
    route: ActivatedRoute
  ) {
    this.alwaysShowCalendars = true;
    this.siteId = this.activeRoute.snapshot.queryParams['siteId']; // 'JAPBOSCH30201064';
    this.alertType = this.activeRoute.snapshot.queryParams['alertType'];
    if (this.alertType != 'Solar') {
      this.alertType = 'Other';
    }
  }

  ngOnInit() {}

  /**
   * Set the paginator after the view init since this component will
   * be able to query its view for the initialized paginator.
   */
  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    // this.faultdata.paginator = this.paginator;
  }

  ngOnDestroy() {
    // reset pageSize because same service instance is used in other examples
  }

  notifications() {
    const t = this;

    const fromDate =
      t.notificationDefaultQuery === true
        ? undefined
        : moment(
            t.notificationDateRange.startDate
              ? t.notificationDateRange.startDate.valueOf()
              : ''
          )
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');

    const toDate =
      t.notificationDefaultQuery === true
        ? undefined
        : moment(
            t.notificationDateRange.endDate
              ? t.notificationDateRange.endDate.valueOf()
              : ''
          )
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');

    t.notificationForm = {
      issuedAlertAll: false,
      selectedIssuedAlerts: []
    };
    t.siteService
      .fetchIssuedAlerts(t.siteId, fromDate, toDate, this.alertType)
      .subscribe((data) => {
        let i = 0;

        this.issuedAlerts = data.map(function (item) {
          i = i + 1;
          return {
            id: i.toString(),
            alertID: item.alertID,
            isRead: item.isRead,
            refNo: item.refNo,
            criticalityLevel: item.criticalityLevel,
            loadName: item.alertConditions[0].load.name,
            parameter: item.alertConditions[0].parameter,
            conditionOperator: item.alertConditions[0].conditionOperator,
            conditionValue: item.alertConditions[0].conditionValue,
            firstStartTime: item.firstStartTime,
            occurrenceCounter: item.occurrenceCounter,
            lastStartTime: item.lastStartTime,
            lastEndTime: item.lastEndTime
          };
        });
        t.dataSource = new MatTableDataSource<NotificationModel>(
          this.issuedAlerts
        );
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    t.siteService
      .fetchGeneratedFaults(t.siteId, fromDate, toDate)
      .subscribe((data) => {
        let i = 0;
        this.generatedFaults = data.map(function (item) {
          i = i + 1;
          return {
            slno: i.toString(),
            faultname: item.faultname,
            loadname: item.deviceName,
            starttime: item.starttime,
            endtime: item.endtime,
            status: item.faultStatus
          };
        });
        this.faultarray = this.generatedFaults;
        this.totalSize = this.faultarray.length;
        this.faultiterator();
        this.faultdata.paginator = this.paginator;
        this.faultdata.sort = this.sort;
      });
  }
  public faulthandlePage(e: any) {
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.faultiterator();
  }
  private faultiterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.faultarray.slice(start, end);
    this.faultdata = part;
  }

  markAlerts(isRead) {
    const t = this;
    if (t.notificationForm.selectedIssuedAlerts.length > 0) {
      t.siteService
        .setAlertIsReadByRIds(t.notificationForm.selectedIssuedAlerts, isRead)
        .subscribe((data) => {
          if (data === true) {
            this.alertService.message = Constants.MESSAGE.Save_success;
            this.alertService.showSuccess();
            t.notifications();
          } else {
            this.alertService.message = Constants.MESSAGE.Save_failure;
            this.alertService.showError();
          }
        });
    }
  }

  exportIssuedAlerts() {
    const t = this;
    if (
      t.notificationDateRange.startDate === null &&
      t.notificationDateRange.endDate === null
    ) {
      return;
    }
    const fromDate =
      t.notificationDefaultQuery === true
        ? undefined
        : t.transformDate(
            t.notificationDateRange.startDate.valueOf(),
            Constants.DATE.DATE_FORMAT
          );

    const toDate =
      t.notificationDefaultQuery === true
        ? undefined
        : t.transformDate(
            t.notificationDateRange.endDate.valueOf(),
            Constants.DATE.DATE_FORMAT
          );
    const url =
      t.siteService.getExportIssuedAlertsUrl() +
      '/' +
      t.siteId +
      '/' +
      fromDate +
      '/' +
      toDate +
      '/' +
      Constants.ALERT_FOR_TYPE.SOLAR;
    window.open(url, '_self');
  }

  deleteAlerts() {
    const t = this;
    if (t.notificationForm.selectedIssuedAlerts.length > 0) {
      const dialogRef = this.dialog.open(ConfirmationDialog, {
        width: '500px'
      });
      dialogRef.componentInstance.confirmMessage =
        Constants.MESSAGE.Delete_Alerts;
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          t.siteService
            .deleteIssuedAlertByRIds(t.notificationForm.selectedIssuedAlerts)
            .subscribe((data) => {
              if (data === true) {
                this.alertService.message = Constants.MESSAGE.Delete_success;
                this.alertService.showSuccess();
                t.notifications();
              } else {
                this.alertService.message = Constants.MESSAGE.Delete_failure;
                this.alertService.showError();
              }
            });
        }
      });
    }
  }

  checkAllIssuedAlert(event) {
    if (this.notificationForm.issuedAlertAll) {
      this.notificationForm.selectedIssuedAlerts = this.issuedAlerts.map(
        function (item) {
          item.select = true;
          return item.alertID;
        }
      );
    } else {
      this.issuedAlerts.map(function (item) {
        item.select = false;
      });
      this.notificationForm.selectedIssuedAlerts = [];
    }
  }

  checkForAllIssuedAlert() {
    if (this.issuedAlerts.length > 0) {
      this.notificationForm.issuedAlertAll =
        this.notificationForm.selectedIssuedAlerts.length ===
        this.issuedAlerts.length
          ? true
          : false;
    }
  }

  changeDateRangeForNotification() {
    if (
      moment(this.notificationDateRange.endDate).diff(
        moment(this.notificationDateRange.startDate),
        'days'
      ) >= 31
    ) {
      this.commonService.showDialogMessage(
        'Note: Data display limited to 31 days. Please select duration not more than 31 days'
      );
      return;
    }

    if (
      this.commonService.isLaterThanCurentDate(
        this.notificationDateRange.endDate
      )
    ) {
      this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
      return;
    }
    this.notificationDefaultQuery = false;
    this.notifications();
  }

  transformDate(date: any, format: string): string {
    return this.datePipe.transform(date, format) || '';
  }
  onClick(alertID: string) {
    const t = this;
    const index = t.notificationForm.selectedIssuedAlerts.findIndex(
      (value) => value === alertID
    );
    const item = this.issuedAlerts.find((value) => value.alertID === alertID);
    item.select = !item.select;
    if (index >= 0) {
      t.notificationForm.selectedIssuedAlerts.pop(alertID);
    } else {
      t.notificationForm.selectedIssuedAlerts.push(alertID);
    }
    t.checkForAllIssuedAlert();
  }
}
export interface NotificationModel {
  id?: string;
  alertID?: string;
  isRead?: boolean;
  refNo?: string;
  criticalityLevel?: string;
  loadName?: string;
  parameter?: string;
  ConditionwithValue?: string;
  firstStartTime?: string;
  occurrenceCounter?: string;
  lastStartTime?: string;
  lastEndTime?: string;
  slno?: string;
  faultname?: string;
  loadname?: string;
  starttime?: string;
  endtime?: string;
  status?: string;
}
